import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  InfoButton,
  Label,
} from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"

import styles from "./Ranges.module.scss"
import { SleepHoursInputs } from "src/components"
import { usePolyglot } from "src/contexts"
import { useTrackSleepSettings } from "src/hooks"

const polyglotPrefix = "pages.settings.ranges.sleep_hours."

interface Props {
  updatedAt?: string;
  updateFollow: (settings: Partial<Follow>) => void;
}

export function SleepHours(props: Props) {
  const { updateFollow } = props

  const polyglot = usePolyglot()
  const trackSleepSettings = useTrackSleepSettings()

  const onBlur = useCallback(
    (sleepSettings: Follow["sleep_settings"]) => {
      updateFollow({
        sleep_settings: sleepSettings,
      })

      trackSleepSettings(sleepSettings)
    },
    [
      updateFollow,
      trackSleepSettings,
    ],
  )

  return (
    <div>
      <Label id ="sleep-time-label">
        {polyglot.t(`${polyglotPrefix}label`)}
        <InfoButton title={polyglot.t(`${polyglotPrefix}title`)}>
          <div>
            {polyglot.t(`${polyglotPrefix}description_one`)}
          </div>
          <div>
            {polyglot.t(`${polyglotPrefix}description_two`)}
          </div>
        </InfoButton>
      </Label>
      <SleepHoursInputs
        className={styles.inputContainer}
        onBlur={onBlur}
      />
    </div>
  )
}
